import { Check } from 'lucide-react';

import type { BenefitsProps } from './useBenefits';

const BenefitsMobile = ({ data }: BenefitsProps) => {
  return (
    <section id="benefits" className="flex flex-col bg-surface-primary">
      <div
        className="h-64 w-full bg-cover bg-center"
        style={{ backgroundImage: `url(${data.backgroundImage})` }}
      />

      <div className="flex flex-col gap-8 px-6 py-12">
        <span className="font-body text-xs font-semibold tracking-widest text-accent-text">
          {data.label}
        </span>
        <h2 className="font-heading text-3xl font-medium leading-tight text-foreground-primary whitespace-pre-line">
          {data.title}
        </h2>

        <div className="flex flex-col gap-5">
          {data.benefits.map((benefit, index) => (
            <div key={index} className="flex items-start gap-4">
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-accent-primary">
                <Check className="h-4 w-4 text-surface-inverse" />
              </div>
              <span className="font-body text-base text-foreground-primary">
                {benefit}
              </span>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-4">
          {data.stats.map((stat) => (
            <div key={stat.id} className="flex flex-col gap-1 text-center">
              <span className="font-heading text-2xl font-semibold text-accent-text">
                {stat.value}
              </span>
              <span className="font-body text-xs font-medium text-foreground-secondary">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsMobile;
